import React from "react"
import PropTypes from "prop-types"

/**
 * Tarjeta grande de indicador. `variante` elige entre la clara, la clara con
 * franja de acento y la oscura del diseño.
 */
const KpiCard = ({ label, icono, valor, unidad, hint, formato, variante, children }) => (
  <div className={`res-kpi${variante ? ` is-${variante}` : ""}`}>
    <div className="res-kpi-head">
      <span className="res-kpi-label">{label}</span>
      {icono && (
        <div className="res-kpi-icon">
          <i className={icono}></i>
        </div>
      )}
    </div>

    <div>
      {/* Los importes llevan otro tamaño: completos no caben en una línea. */}
      <div className={`res-kpi-value${formato === "money" ? " is-money" : ""}`}>
        <span>{valor}</span>
        {unidad && <span className="res-kpi-unit">{unidad}</span>}
      </div>

      {children}

      {hint && <div className="res-kpi-hint">{hint}</div>}
    </div>
  </div>
)

KpiCard.propTypes = {
  label: PropTypes.string.isRequired,
  icono: PropTypes.string,
  valor: PropTypes.any,
  unidad: PropTypes.string,
  hint: PropTypes.any,
  formato: PropTypes.oneOf(["money"]),
  variante: PropTypes.oneOf(["accent", "dark"]),
  children: PropTypes.any,
}

export default KpiCard
